import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { getApiBaseUrl, getUserTimeZone } from "../api/api";
import { jwtAfterUsersMeResponse } from "../api/StorageApi";
import { requests } from "../api/apiUtils";
import { buildChromeLoginJwtContext } from "./login/chromeJwtContext";

const getCurrentUser = (token) => {
  return requests({
    method: "GET",
    url: `${getApiBaseUrl()}/users/me`,
    headers: {
      "X-User-Tz": getUserTimeZone(),
      "X-User-Language": window.navigator.language,
      NeedCheckSaleCRMLicense: window.needCheckSaleCRMLicense,
      Authorization: `JWT ${token}`,
    },
  });
};

const ChromeExtension = () => {
  const { extensionId, email } = useParams();

  useEffect(() => {
    if (!extensionId || !email) return;
    const params = new URLSearchParams(window.location.search);
    const jwt = params.get("jwt");
    const expectedContext = buildChromeLoginJwtContext(extensionId, email);
    const jwtContext = params.get("jwtContext");
    const contextMatches = jwtContext == null || jwtContext === expectedContext;
    if (jwt) {
      getCurrentUser(jwt).then((response) => {
        const { data } = response;
        const token = jwtAfterUsersMeResponse(response.headers, jwt);
        if (data && data.accountId === email && contextMatches) {
          window.opener.postMessage(
            {
              id: extensionId,
              type: "GOOGLE_AUTH_SUCCESS",
              token,
              jwtContext: expectedContext,
            },
            "https://mail.google.com"
          );
          window.close();
        } else {
          window.opener.postMessage(
            {
              id: extensionId,
              type: "GOOGLE_AUTH_FAIL",
            },
            "https://mail.google.com"
          );
          window.close();
        }
      });
    } else {
      window.opener.postMessage(
        {
          id: extensionId,
          type: "GOOGLE_AUTH_FAIL",
        },
        "https://mail.google.com"
      );
      window.close();
    }
  }, [extensionId, email]);

  return (
    <div className="w-full h-full pt-16 flex justify-center">
      <div className="text-center">
        <div className="flex justify-center mb-8">
          <img className="w-10" src="https://typecrm.net/static/images/logo.svg" alt="Type+" />
        </div>

        <h1 className="text-2xl font-semibold text-gray-900">Processing data...</h1>
      </div>
    </div>
  );
};

export default ChromeExtension;
